import { useMemo, useState } from 'react'
import { business, products } from '../data/products'

const money = (value) => new Intl.NumberFormat(business.locale, {
  style: 'currency', currency: business.currency, maximumFractionDigits: 2,
}).format(value)

export function ProductSection() {
  const [selectedId, setSelectedId] = useState(products[0].id)
  const [quantity, setQuantity] = useState(1)
  const selected = useMemo(() => products.find((item) => item.id === selectedId) ?? products[0], [selectedId])
  const total = selected.price * quantity
  const updateQuantity = (value) => setQuantity(Math.max(1, Math.min(20, Number(value) || 1)))

  const order = (event) => {
    event.preventDefault()
    const message = [
      'Hello Alshifaa Honey, I would like to place an order:', '',
      '• Product: Alshifaa Pure Honey',
      `• Size: ${selected.size}`,
      `• Quantity: ${quantity}`,
      `• Total: ${money(total)}`, '',
      'Please confirm availability and delivery details. Thank you.',
    ].join('\n')
    const whatsappUrl = 'https:' + '//wa.me/' + business.whatsapp + '?text=' + encodeURIComponent(message)
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <section className="product section" id="order">
      <div className="container product-grid">
        <div className="product-variant-visual" aria-live="polite">
          <figure>
            <img src={selected.image} alt={selected.alt} />
            <figcaption><span>{selected.size}</span><strong>{money(selected.price)}</strong></figcaption>
          </figure>
          <span className="seal">100%<br />PURE</span>
        </div>
        <div className="product-info">
          <p className="eyebrow">ALSHIFAA PURE HONEY</p>
          <h2>Your everyday jar of pure goodness.</h2>
          <div className="rating" aria-label="Five stars">★★★★★ <span>Naturally loved</span></div>
          <p className="product-description">Drizzle it over breakfast, stir it into tea, or enjoy it straight from the spoon. Every drop is simply pure honey.</p>
          <form onSubmit={order}>
            <fieldset>
              <legend>Choose your size</legend>
              <div className="size-options">
                {products.map((item) => (
                  <label className="size-choice" key={item.id}>
                    <input type="radio" name="size" value={item.id} checked={selectedId === item.id} onChange={() => setSelectedId(item.id)} />
                    <span><b>{item.size}</b><small>{money(item.price)}</small></span>
                  </label>
                ))}
              </div>
            </fieldset>
            <div className="quantity-row">
              <label htmlFor="quantity">Quantity</label>
              <div className="stepper">
                <button type="button" onClick={() => updateQuantity(quantity - 1)} aria-label="Decrease quantity">−</button>
                <input id="quantity" type="number" min="1" max="20" value={quantity} onChange={(event) => updateQuantity(event.target.value)} />
                <button type="button" onClick={() => updateQuantity(quantity + 1)} aria-label="Increase quantity">+</button>
              </div>
            </div>
            <div className="total-row"><span>Your total</span><strong>{money(total)}</strong></div>
            <button className="button button-wide" type="submit">Order on WhatsApp <span aria-hidden="true">↗</span></button>
            <p className="form-note">You will confirm delivery details securely on WhatsApp.</p>
          </form>
        </div>
      </div>
    </section>
  )
}
